import { useEffect, useRef } from 'react';

export const useEventListener = <K extends keyof (DocumentEventMap & WindowEventMap)>(
  eventName: K,
  handler: (event: (DocumentEventMap & WindowEventMap)[K]) => void,
  element: Document | HTMLElement | Window = document,
) => {
  const savedHandler = useRef<(event: (DocumentEventMap & WindowEventMap)[K]) => void>();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!element?.addEventListener) {
      return;
    }

    const abortController = new AbortController();
    const signal = abortController.signal;

    const eventListener = (event: Event) => {
      savedHandler.current?.(event as (DocumentEventMap & WindowEventMap)[K]);
    };

    element.addEventListener(eventName, eventListener, { signal });

    return () => {
      abortController.abort();
    };
  }, [eventName, element]);
};
